/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import AppVersion from '../../../client/js/components/AppVersion'
import PageTitle from '../../../client/js/components/PageTitle'
import { getSignInLink } from '../../auth/lib/authLinks'
import { Box, Card, Stack, Text } from '@mantine/core'
import AnchorLink from '../../../client/js/components/AnchorLink'
import Page from '../../../client/js/components/Page'

function ResetPasswordSuccessPage () {
  const intl = useIntl()
  return (
    <Page>
      <Stack w="100%" maw={450}>
        <Card shadow="sm" p="xl">
          <Stack>
            <PageTitle
              size="h2"
              title={intl.formatMessage({
                id: 'password_changed',
                defaultMessage: 'Mot de passe modifié'
              })}
            />
            <Text>
              <FormattedMessage
                id="password_changed_confirmation"
                defaultMessage="Votre nouveau mot de passe a été pris en compte, vous pouvez désormais vous connecter en utilisant votre nouveau mot de passe."
              />
            </Text>
            <Box ta="center">
              <AnchorLink to={getSignInLink()}>
                <FormattedMessage
                  id="sign_in"
                  defaultMessage="Se connecter"
                />
              </AnchorLink>
            </Box>
          </Stack>
        </Card>
        <Text ta="center">
          <AppVersion />
        </Text>
      </Stack>
    </Page>
  )
}

export default ResetPasswordSuccessPage
